import _implicitStylesheets from "./videoPreviewV2.css";
import _implicitScopedStylesheets from "./videoPreviewV2.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<img${"a0:src"} class="preview__background${0}"${"a0:alt"}${2}>`;
const stc0 = {
  "type": "image"
};
const stc1 = {
  classMap: {
    "preview": true
  },
  attrs: {
    "role": "presentation"
  },
  key: 1
};
const stc2 = {
  classMap: {
    "preview__content": true
  },
  key: 4
};
const stc3 = {
  classMap: {
    "play__button": true
  },
  key: 5
};
const stc4 = {
  classMap: {
    "play__icon": true
  },
  props: {
    "size": "large",
    "icon": "play",
    "ariaHidden": "true"
  },
  key: 6
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element} = $api;
  const {_m0} = $ctx;
  return [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
    props: stc0,
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [api_element("div", stc1, [api_static_fragment($fragment1, 3, [api_static_part(0, {
    attrs: {
      "src": $cmp.posterSrc,
      "alt": $cmp.altText
    }
  }, null)]), api_element("div", stc2, [api_element("div", stc3, [api_custom_element("ax-icon", _axIcon, stc4)])])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2kq7f7467k5";
tmpl.legacyStylesheetToken = "undefined-_videoPreviewV2";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
